/**
 * Sample-rate bounds a browser `AudioContext` will accept for a decoded PCM
 * buffer. Shared so the credential parser and the audio-format reader cannot
 * drift apart on what counts as playable.
 *
 * `insforge/functions-src/elevenlabs-agent-session/index.ts` enforces the same
 * range on `ELEVENLABS_AGENT_OUTPUT_SAMPLE_RATE`. It runs on Deno and cannot
 * import from `src/`, so it restates these two numbers and
 * `tests/infra/voice-sample-rate-parity.test.ts` fails if the copies drift.
 */
export const MIN_SAMPLE_RATE = 8000;
export const MAX_SAMPLE_RATE = 48_000;

/** True when the rate is a whole number the browser can actually play. */
export function isPlayableSampleRate(value: unknown): value is number {
  if (typeof value !== "number" || !Number.isInteger(value)) {
    return false;
  }
  return value >= MIN_SAMPLE_RATE && value <= MAX_SAMPLE_RATE;
}
